import type { ReactNode } from "react";

import Banner from "ds/components/Banner";
import Link from "ds/components/Link";
import { StackVendor } from "types/generated";

import { OPEN_TOFU_MIGRATION_BEFORE_YOU_MIGRATE_URL } from "./constants";

type OpenTofuMigrationProviderWarningTarget = StackVendor.OpenTofu | StackVendor.Terraform;

const TEXT: Record<OpenTofuMigrationProviderWarningTarget, ReactNode> = {
  [StackVendor.OpenTofu]: (
    <>
      If you manage a stack with the Spacelift Terraform provider, change its{" "}
      <strong>spacelift_stack</strong> resource to the <strong>opentofu</strong> block after the
      migration. Otherwise, the next apply of the stack that manages its settings fails.
    </>
  ),
  [StackVendor.Terraform]: (
    <>
      If you manage a stack with the Spacelift Terraform provider, change its{" "}
      <strong>spacelift_stack</strong> resource back to <strong>terraform_workflow_tool</strong>{" "}
      <strong>OPEN_TOFU</strong> after the rollback. Otherwise, the next apply of the stack that
      manages its settings fails.
    </>
  ),
};

type OpenTofuMigrationProviderWarningProps = {
  target: OpenTofuMigrationProviderWarningTarget;
};

const OpenTofuMigrationProviderWarning = ({ target }: OpenTofuMigrationProviderWarningProps) => (
  <Banner variant="warning">
    {TEXT[target]} See{" "}
    <Link href={OPEN_TOFU_MIGRATION_BEFORE_YOU_MIGRATE_URL} target="_blank">
      Before you migrate
    </Link>
    .
  </Banner>
);

export default OpenTofuMigrationProviderWarning;
